<template>
    <div class="l-listings staff">
        <div class="container">
            <div class="row">
                <staff-list-item v-for="searchResult in searchResults" :key="searchResult.Id" :result-item="searchResult" :location-link="locationLink"></staff-list-item>
            </div>
            <div class="e-viewmore">
                <span>Showing {{resultsLoaded}} of {{resultCount}} results</span>

                <search-pager v-if="moreResultsAvailable"></search-pager>
            </div>
        </div>
    </div>
</template>

<script>
    import Globals from '@/globals.js'
    import SearchPager from '@/components/SiteSearch/search-pager'
    import StaffListItem from '@/components/StaffSearch/staff-list-item'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'
    import { format, toDate } from '@/utils/date.js'

    export default {
        components: {
            SearchPager,
            StaffListItem
        },

        computed: {
            moreResultsAvailable: function () {
                return this.$store.getters.moreResultsAvailable
            },

            resultCount: function () {
                return this.$store.state.search.resultCount
            },

            resultsLoaded: function () {
                return this.$store.state.search.resultsLoaded
            },

            searchResults: function () {
                return this.$store.state.search.results
            }
        },

        created: function () {
            this.$eventHub.$on('search-filtersChanged', this.onFiltersChanged)
            this.$eventHub.$on('search-pageChanged', this.onPageChanged)

            this.search()
        },

        data() {
            return {
                searchApiUrl: '/umbraco/api/StaffSearchApi/Search'
            }
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },

            onFiltersChanged: function () {
                this.search(true)
            },

            onPageChanged: function () {
                this.search()
            }
        },

        mixins: [globalMixin, searchMixin],

        props: {
            locationLink: {
                type: String
            }
        }
    }
</script>